<template>
  <div>
    <IconButton
      aria-label="Share this profile"
      color="gray100"
      filled
      @click="handleShare"
    >
      <ExportIcon title="share" />
    </IconButton>
  </div>
</template>

<script>
import { IconButton, ExportIcon, EVENTS } from '@campsite-bio/component-lib';
import { computed, useContext } from '@nuxtjs/composition-api';

export default {
  components: {
    IconButton,
    ExportIcon,
  },

  setup() {
    const { store, $trackEvent } = useContext();

    const campsite = computed(() => store.state.campsite);

    async function handleShare() {
      // Get the full current URL with only the path
      const urlToShare = `${window.location.origin}${window.location.pathname}`;

      try {
        await window.navigator.share({
          title: 'Campsite.bio',
          text: 'Check out this profile on Campsite.bio!',
          url: urlToShare,
        });

        $trackEvent(
          [
            {
              event_name: EVENTS.SHARE,
              epoch: Date.now(),
            },
          ],
          {
            campsite_id: campsite.value._id.$oid,
          },
        );

        // eslint-disable-next-line no-empty
      } catch (e) {}
    }

    return { handleShare };
  },
};
</script>

<style lang="scss" scoped></style>
